import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative h-[560px] md:h-[720px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={`${import.meta.env.BASE_URL}images/684eb47678b0e5b7.jpg`}
          alt="John Holt PLC industrial power facility"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/55 to-foreground-950/85"></div>
      </div>

      <div className="relative z-10 w-full mx-auto max-w-[1440px] px-4 md:px-8">
        <div className="max-w-2xl animate-fade-up">
          <span className="inline-flex items-center gap-2 text-xs md:text-sm font-semibold tracking-[0.2em] uppercase text-accent-300 bg-background-50/10 border border-background-50/20 rounded-full px-4 py-1.5">
            Est. 1897 &middot; Nigeria
          </span>
          <h1 className="font-heading mt-6 text-4xl md:text-6xl font-semibold text-background-50 leading-[1.08]">
            Engineering Power, Safety &amp; Progress for Nigeria
          </h1>
          <p className="mt-5 text-base md:text-lg text-background-200 leading-relaxed max-w-xl">
            John Holt PLC brings decades of heritage and technical excellence to power generation, fire safety,
            and engineering solutions — trusted by businesses, institutions and industries nationwide.
          </p>
          <div className="mt-8 flex flex-wrap gap-4">
            <Link
              to="/contact"
              className="cursor-pointer whitespace-nowrap px-7 py-3.5 rounded-full bg-accent-500 text-foreground-950 text-sm font-semibold hover:bg-accent-600 transition-colors"
            >
              Request a Quote
            </Link>
            <Link
              to="/services"
              className="cursor-pointer whitespace-nowrap px-7 py-3.5 rounded-full bg-background-50/10 border border-background-50/30 text-background-50 text-sm font-semibold hover:bg-background-50/20 transition-colors flex items-center gap-2"
            >
              Explore Our Services
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>

      <button
        onClick={() => document.getElementById('home-stats')?.scrollIntoView({ behavior: 'smooth' })}
        aria-label="Scroll to learn more"
        className="cursor-pointer hidden md:flex absolute bottom-8 left-1/2 -translate-x-1/2 z-10 w-11 h-11 rounded-full border border-background-50/40 text-background-50 items-center justify-center hover:bg-background-50/10 transition-colors"
      >
        <i className="ri-arrow-down-line text-xl"></i>
      </button>
    </section>
  );
}